import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchInputProps {
  defaultValue?: string;
  size?: 'md' | 'lg';
  placeholder?: string;
  onSearch?: (keyword: string) => void;
}

export default function SearchInput({
  defaultValue = '',
  size = 'md',
  placeholder = '搜索电影、电视剧、影视资讯',
  onSearch
}: SearchInputProps) {
  const [keyword, setKeyword] = useState(defaultValue);
  const navigate = useNavigate();

  useEffect(() => {
    setKeyword(defaultValue);
  }, [defaultValue]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    if (onSearch) {
      onSearch(value);
      return;
    }
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : '/search');
  };

  const isLarge = size === 'lg';

  return (
    <form onSubmit={handleSubmit} className="w-full" role="search">
      <div
        className={`flex items-center gap-2 rounded-full border border-background-300 bg-background-50 pl-4 pr-1.5 transition focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100 ${
          isLarge ? 'h-14' : 'h-10'
        }`}
      >
        <i className={`ri-search-line text-foreground-400 ${isLarge ? 'text-xl' : 'text-base'}`} />
        <input
          type="search"
          name="keyword"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder={placeholder}
          className={`flex-1 bg-transparent text-foreground-900 placeholder:text-foreground-400 focus:outline-none ${
            isLarge ? 'text-base' : 'text-sm'
          }`}
          aria-label="站内搜索"
        />
        <button
          type="submit"
          className={`flex shrink-0 items-center justify-center gap-1 rounded-full bg-primary-500 font-medium text-background-50 transition hover:bg-primary-600 whitespace-nowrap ${
            isLarge ? 'h-11 px-6 text-sm' : 'h-8 px-4 text-xs'
          }`}
        >
          <i className="ri-search-line" />
          <span className="hidden sm:inline">搜索</span>
        </button>
      </div>
    </form>
  );
}